module.exports = __webpack_public_path__ + "static/media/btn-addwhite.d2e8c2ed.svg";